module.exports = __webpack_public_path__ + "static/img/06.387cd7e1.png";